
import { Rocket, DollarSign, LineChart, Zap, Lightbulb, Target } from "lucide-react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

const StartupBenefits = () => {
  const benefits = [
    { 
      icon: <Rocket className="h-10 w-10 text-amber-500" />, 
      title: "5-Minute Launch", 
      description: "From idea to live campaign in just 5 minutes. No complex setup, no learning curve—just fast results when speed matters most."
    },
    { 
      icon: <DollarSign className="h-10 w-10 text-amber-500" />, 
      title: "Budget Stretcher", 
      description: "AI optimization makes your limited startup budget work 3x harder. Every dollar counts when you're bootstrapping growth."
    },
    { 
      icon: <LineChart className="h-10 w-10 text-amber-500" />, 
      title: "Quick Market Testing", 
      description: "Test new markets, audiences, and messaging in hours, not weeks. Validate your ideas before you fully commit resources."
    },
    { 
      icon: <Zap className="h-10 w-10 text-amber-500" />, 
      title: "Speed-to-Market", 
      description: "While competitors plan, you're already testing. Get to market faster with campaigns that launch the moment you're ready."
    },
    { 
      icon: <Lightbulb className="h-10 w-10 text-amber-500" />, 
      title: "Rapid Iteration", 
      description: "Test, learn, pivot. Make changes to your campaigns in real-time as you discover what works for your startup."
    },
    { 
      icon: <Target className="h-10 w-10 text-amber-500" />, 
      title: "Lean Budget Focus", 
      description: "Built for startups with small budgets. Start with $100/month and scale as you grow and validate your market."
    },
  ];

  return (
    <div className="mb-16">
      <div className="text-center mb-10">
        <h2 className="text-3xl font-bold mb-4">Why Startups Choose Speed Over Everything</h2>
        <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
          When you're racing against time and budget constraints, you need a platform that moves as fast as you do.
        </p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {benefits.map((benefit, index) => (
          <Card key={index} className="bg-card border-amber-200">
            <CardHeader className="pb-2">
              <div className="mb-4">{benefit.icon}</div>
              <CardTitle className="text-xl">{benefit.title}</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground">{benefit.description}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default StartupBenefits;
